import { Draggable } from "@hello-pangea/dnd";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import styled from "styled-components";

const Card = styled.div`
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TaskDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const TaskTitle = styled.h3`
  font-size: 16px;
  margin: 0;
  color: #333;
`;

const TaskDescription = styled.p`
  font-size: 14px;
  margin: 4px 0 0;
  color: #666;
`;

const TaskCard = ({ task, index, onEdit, onRemove }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editedTask, setEditedTask] = useState(task);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEditModalOpen = () => {
    setAnchorEl(null);
    setIsEditModalOpen(true);
  };

  const handleEditModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handleEditSubmit = () => {
    if (onEdit) {
      onEdit(editedTask); // Passa a tarefa editada para o método onEdit
    }
    setIsEditModalOpen(false);
  };

  return (
    <Draggable draggableId={task.id} index={index}>
      {(provided) => (
        <>
          <Card
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <TaskDetails>
              <TaskTitle>{task.title}</TaskTitle>
              <TaskDescription>{task.description}</TaskDescription>
            </TaskDetails>
            <IconButton onClick={handleMenuOpen}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={handleEditModalOpen}>Editar</MenuItem>
              <MenuItem onClick={() => onRemove(task.id)}>Excluir</MenuItem>
            </Menu>
          </Card>

          <Dialog open={isEditModalOpen} onClose={handleEditModalClose}>
            <DialogTitle>Editar Tarefa</DialogTitle>
            <DialogContent>
              <TextField
                label="Título"
                value={editedTask.title}
                onChange={(e) =>
                  setEditedTask({ ...editedTask, title: e.target.value })
                }
                fullWidth
              />
              <TextField
                label="Descrição"
                value={editedTask.description}
                onChange={(e) =>
                  setEditedTask({ ...editedTask, description: e.target.value })
                }
                fullWidth
                multiline
                rows={4}
                style={{ marginTop: "16px" }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleEditModalClose}>Cancelar</Button>
              <Button onClick={handleEditSubmit}>Salvar</Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </Draggable>
  );
};

export default TaskCard;
